// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"405e3785","235":"f314e6ed","336":"1c877a36","374":"1c877a36","606":"2eede794","617":"f314e6ed","818":"08f7dcd2","868":"1c877a36"}[chunkId] + ".chunk.css";
};